import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-footer',
    template: `<div class="layout-footer">
        ISUPPLEANCE ADMIN TOOLS Developed by
        <a target="_blank" rel="noopener noreferrer" class="text-primary font-bold hover:underline">Solutions Clients</a>
    </div>`
})
export class AppFooter {}
